import { render } from "./GasCylindersTable.vue?vue&type=template&id=0988eed0&ts=true"
import script from "./GasCylindersTable.vue?vue&type=script&lang=ts"
export * from "./GasCylindersTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__